export const LOG_LEVEL_ERROR = 0
export const LOG_LEVEL_WARNING = 1
export const LOG_LEVEL_INFO = 2
export const LOG_LEVEL_VERBOSE = 3
export const LOG_LEVEL_DEBUG = 4

// TODO: STUB, IMPLEMENTAR
export const logger_backend_service = async (log_level, module, ...params) => {
  if(typeof params === 'string') {
    return params
  }
  if(Array.isArray(params)) {
    // params.filter(param=>typeof param !=='string') // ignore
    return params.filter(param => typeof param === 'string')
  }
  return 'error unprocesable -ver codigo-'
  // await axios.post(REACT_APP_API + '/apis/logs', body)
  // TODO: implementar bien respuestas de log en backend. luego retornar respuesta
}

const NO_BACKEND_LOGIN_RESPONSE = null

export function LoggerVerbose(modulo, ...params) {
  return (dispatch, getState) => {
    const state = getState()
    const CURRENT_LOG_LEVEL = state.common.CURRENT_LOG_LEVEL
    if (CURRENT_LOG_LEVEL >= LOG_LEVEL_VERBOSE) {
      return logger_backend_service(LOG_LEVEL_VERBOSE, modulo, ...params)
        .then((res) => {
          console.debug(modulo, ...params, res)
          return res
        })
        .catch((err) => {
          console.debug('Error al loggear', err)
        })
    } else {
      console.debug(modulo, ...params)
      return Promise.resolve(NO_BACKEND_LOGIN_RESPONSE)
    }
  }
}

export function LoggerWarning(modulo, ...params) {
  return (dispatch, getState) => {
    const state = getState()
    const CURRENT_LOG_LEVEL = state.common.CURRENT_LOG_LEVEL
    if (CURRENT_LOG_LEVEL >= LOG_LEVEL_WARNING) {
      return logger_backend_service(LOG_LEVEL_WARNING, modulo, ...params)
        .then((res) => {
          console.warn(modulo, ...params, res)
          return res
        })
        .catch((err) => {
          console.debug('Error al loggear', err)
        })
    } else {
      console.warn(modulo, ...params)
      return Promise.resolve(NO_BACKEND_LOGIN_RESPONSE)
    }
  }
}

export function LoggerInfo(modulo, ...params) {
  return (dispatch, getState) => {
    const state = getState()
    const CURRENT_LOG_LEVEL = state.common.CURRENT_LOG_LEVEL
    if (CURRENT_LOG_LEVEL >= LOG_LEVEL_INFO) {
      return logger_backend_service(LOG_LEVEL_INFO, modulo, ...params)
        .then((res) => {
          console.log(modulo, ...params, res)
          return res
        })
        .catch((err) => {
          console.debug('Error al loggear', err)
        })
    } else {
      console.log(modulo, ...params)
      return Promise.resolve(NO_BACKEND_LOGIN_RESPONSE)
    }
  }
}

export function LoggerDebug(modulo, ...params) {
  return (dispatch, getState) => {
    const state = getState()
    const CURRENT_LOG_LEVEL = state.common.CURRENT_LOG_LEVEL
    if (CURRENT_LOG_LEVEL >= LOG_LEVEL_DEBUG) {
      return logger_backend_service(LOG_LEVEL_DEBUG, modulo, ...params)
        .then((res) => {
          console.debug(modulo, ...params, res)
          return res
        })
        .catch((err) => {
          console.debug('Error al loggear', err)
        })
    } else {
      console.debug(modulo, ...params)
      return Promise.resolve(NO_BACKEND_LOGIN_RESPONSE)
    }
  }
}

export function LoggerError(modulo, err, ...params) {
  return (dispatch, getState) => {
    const state = getState()
    const CURRENT_LOG_LEVEL = state.common.CURRENT_LOG_LEVEL
    if (CURRENT_LOG_LEVEL >= LOG_LEVEL_ERROR) {
      return logger_backend_service(LOG_LEVEL_ERROR, modulo, ...params)
        .then((res) => {
          console.error(modulo, ...params, res, err)
          return res
        })
        .catch((error) => {
          console.debug('Error al loggear', error?.message, error?.stack)
        })
    } else {
      console.error(modulo, ...params)
      return Promise.resolve(NO_BACKEND_LOGIN_RESPONSE)
    }
  }
}

export function reducer(state) {
  return state //do nothing
}
